import { lazy } from "react";
import Loadable from "app/components/Loadable";
import OperationalRouteGuard from "app/components/operational-workspace/OperationalRouteGuard";

const BillingPage = Loadable(lazy(() => import("../billing/BillingPage")));
const UnifiedBillingWorkspacePage = Loadable(
  lazy(() => import("../workspace/pages/UnifiedBillingWorkspacePage")),
);
const BillingOperationalHubPage = Loadable(
  lazy(() => import("../workspace/pages/BillingOperationalHubPage")),
);
const BillingOperationsDeskRedirect = Loadable(
  lazy(() => import("../operations-desk/pages/BillingOperationsDeskRedirect")),
);
const PatientJourneyDeskPage = Loadable(
  lazy(() => import("../operational/pages/PatientJourneyDeskPage")),
);
const IpDischargeDeskPage = Loadable(
  lazy(() => import("../operational/pages/IpDischargeDeskPage")),
);
const ShiftContinuityDeskPage = Loadable(
  lazy(() => import("../operational/pages/ShiftContinuityDeskPage")),
);
const OperationalAlertsDeskPage = Loadable(
  lazy(() => import("../operational/pages/OperationalAlertsDeskPage")),
);
const OperationalRecoveryDeskPage = Loadable(
  lazy(() => import("../operational/pages/OperationalRecoveryDeskPage")),
);
const ProductionReadinessDeskPage = Loadable(
  lazy(() => import("../operational/pages/ProductionReadinessDeskPage")),
);

const RefundReviewPendingQueuePage = Loadable(
  lazy(() => import("../supervisor/pages/RefundReviewPendingQueuePage")),
);
const CounterFinanceAuditPage = Loadable(
  lazy(() => import("../supervisor/pages/CounterFinanceAuditPage")),
);
const FinanceClosePage = Loadable(lazy(() => import("../supervisor/pages/FinanceClosePage")));
const OperationalApprovalQueuePage = Loadable(
  lazy(() => import("../supervisor/pages/OperationalApprovalQueuePage")),
);
const ServiceCatalogPage = Loadable(
  lazy(() => import("../catalog/pages/ServiceCatalogPage")),
);
const IpChargeRulesPage = Loadable(
  lazy(() => import("../catalog/pages/IpChargeRulesPage")),
);
const BillingTariffSetupPage = Loadable(
  lazy(() => import("../catalog/pages/BillingTariffSetupPage")),
);
const InvoicePrintSettingsPage = Loadable(
  lazy(() => import("../print/InvoicePrintSettingsPage")),
);
const PatientDuesPage = Loadable(
  lazy(() => import("../patient-dues/pages/PatientDuesPage")),
);
const PatientDuesDetailPage = Loadable(
  lazy(() => import("../patient-dues/pages/PatientDuesDetailPage")),
);
const IpAdmissionBillingWorkspacePage = Loadable(
  lazy(() => import("../ip-admission/pages/IpAdmissionBillingWorkspacePage")),
);
const IpReceivablesPage = Loadable(
  lazy(() => import("../receivables/pages/IpReceivablesPage")),
);

const BillingRoutes = [
  {
    path: "/billing/patient-dues",
    element: (
      <OperationalRouteGuard moduleId="PATIENT_BILLING_DUES">
        <PatientDuesPage />
      </OperationalRouteGuard>
    ),
  },
  {
    path: "/billing/patient-dues/:patientExternalId",
    element: (
      <OperationalRouteGuard moduleId="PATIENT_BILLING_DUES">
        <PatientDuesDetailPage />
      </OperationalRouteGuard>
    ),
  },
  {
    path: "/billing/ip-admissions/:admissionKey",
    element: (
      <OperationalRouteGuard moduleIds={["OP_BILLING_COUNTER", "IP_DISCHARGE", "PATIENT_BILLING_DUES"]}>
        <IpAdmissionBillingWorkspacePage />
      </OperationalRouteGuard>
    ),
  },
  {
    path: "/billing/receivables",
    element: (
      <OperationalRouteGuard moduleId="BILLING_RECEIVABLES">
        <IpReceivablesPage />
      </OperationalRouteGuard>
    ),
  },
  {
    path: "/billing/workspace",
    element: (
      <OperationalRouteGuard moduleIds={["OP_BILLING_COUNTER", "PHARMACY_COUNTER"]}>
        <UnifiedBillingWorkspacePage />
      </OperationalRouteGuard>
    ),
  },
  {
    path: "/billing/counter",
    element: (
      <OperationalRouteGuard moduleId="OP_BILLING_COUNTER">
        <UnifiedBillingWorkspacePage />
      </OperationalRouteGuard>
    ),
  },
  {
    path: "/billing/operations",
    element: <BillingOperationalHubPage />,
  },
  {
    path: "/billing/patient-journey",
    element: (
      <OperationalRouteGuard moduleId="PATIENT_JOURNEY">
        <PatientJourneyDeskPage />
      </OperationalRouteGuard>
    ),
  },
  {
    path: "/billing/ip-discharge",
    element: (
      <OperationalRouteGuard moduleId="IP_DISCHARGE">
        <IpDischargeDeskPage />
      </OperationalRouteGuard>
    ),
  },
  {
    path: "/billing/shift-continuity",
    element: (
      <OperationalRouteGuard moduleId="SHIFT_CONTINUITY">
        <ShiftContinuityDeskPage />
      </OperationalRouteGuard>
    ),
  },
  {
    path: "/billing/operational-alerts",
    element: (
      <OperationalRouteGuard moduleId="OPERATIONAL_ALERTS">
        <OperationalAlertsDeskPage />
      </OperationalRouteGuard>
    ),
  },
  {
    path: "/billing/operational-recovery",
    element: (
      <OperationalRouteGuard moduleId="OPERATIONAL_RECOVERY">
        <OperationalRecoveryDeskPage />
      </OperationalRouteGuard>
    ),
  },
  {
    path: "/billing/operational-readiness",
    element: (
      <OperationalRouteGuard moduleId="OPERATIONAL_READINESS">
        <ProductionReadinessDeskPage />
      </OperationalRouteGuard>
    ),
  },
  {
    path: "/billing/operations-desk",
    element: <BillingOperationsDeskRedirect />,
  },
  {
    path: "/billing/refund-review-queue",
    element: (
      <OperationalRouteGuard moduleId="REFUND_REVIEW">
        <RefundReviewPendingQueuePage />
      </OperationalRouteGuard>
    ),
  },
  {
    path: "/billing/counter-finance-audit",
    element: (
      <OperationalRouteGuard moduleId="FINANCE_AUDIT">
        <CounterFinanceAuditPage />
      </OperationalRouteGuard>
    ),
  },
  {
    path: "/billing/finance-close",
    element: (
      <OperationalRouteGuard moduleId="FINANCE_AUDIT">
        <FinanceClosePage />
      </OperationalRouteGuard>
    ),
  },
  {
    path: "/billing/operational-approvals",
    element: (
      <OperationalRouteGuard moduleId="BILLING_DISCOUNT_APPROVAL">
        <OperationalApprovalQueuePage />
      </OperationalRouteGuard>
    ),
  },
  {
    path: "/billing/catalog",
    element: (
      <OperationalRouteGuard moduleId="BILLING_SERVICE_CATALOG">
        <ServiceCatalogPage />
      </OperationalRouteGuard>
    ),
  },
  {
    path: "/billing/catalog/ip-charge-rules",
    element: (
      <OperationalRouteGuard moduleId="BILLING_SERVICE_CATALOG">
        <IpChargeRulesPage />
      </OperationalRouteGuard>
    ),
  },
  {
    path: "/setup/billing",
    element: (
      <OperationalRouteGuard moduleId="BILLING_TARIFF_SETUP">
        <BillingTariffSetupPage />
      </OperationalRouteGuard>
    ),
  },
  {
    path: "/setup/billing/print-settings",
    element: (
      <OperationalRouteGuard moduleId="BILLING_TARIFF_SETUP">
        <InvoicePrintSettingsPage />
      </OperationalRouteGuard>
    ),
  },
  {
    path: "/billing",
    element: <BillingPage />,
  },
];

export default BillingRoutes;
